<ae-nav></ae-nav>
<mat-card>
  <mat-card-header mat-card-title>Select Customer</mat-card-header>
  <mat-card-content>
    <div class="customer-selector">
      <select [(ngModel)]="selectedCustomer" (change)="onCustomerChange()">
        <option *ngFor="let customerName of customerList" [value]="customerName">{{ customerName }}</option>
      </select>
    </div>
  </mat-card-content>
</mat-card>
